import PropTypes from 'prop-types'
import { TileBackFolderCardContainer } from '../../../styled-component'
import { ArrowLeft } from '../../../../../components/stories/atoms/icons/essentials'

const ProjectMenuTileBackButton = ({
  hasFolderHistory = false,
  goBackFolder = () => {}
}) => {
  if (!hasFolderHistory) return null

  return (
    <TileBackFolderCardContainer onClick={goBackFolder}>
      <ArrowLeft style={{ width: 144, height: 144 }} />
    </TileBackFolderCardContainer>
  )
}

ProjectMenuTileBackButton.propTypes = {
  hasFolderHistory: PropTypes.bool,
  goBackFolder: PropTypes.func
}

export default ProjectMenuTileBackButton
